import { init } from '@sentry/react';

export const configureSentry = () => {
  if (process.env.REACT_APP_SENTRY_DSN) {
    init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
    });
  }
};
